import { add, format as formatDate } from 'date-fns'

import { formatCurrency } from '@/utils'

export const columnTypes = {
  dateColumn: {
    valueGetter: ({ data, colDef }) => {
      const rawValue = data?.[colDef.field]
      return rawValue ? new Date(rawValue) : null
    },
    valueFormatter: ({ value }) => {
      // Add 12 hours because dates come at 00:00, and get transformed to the previous day in -X UTC TZs
      return value ? formatDate(add(new Date(value), { hours: 12 }), 'LLL dd') : '-'
    },
    filter: 'agDateColumnFilter',
  },

  dateTimeColumn: {
    valueGetter: ({ data, colDef }) => {
      const rawValue = data?.[colDef.field]
      return rawValue ? new Date(rawValue) : null
    },
    valueFormatter: ({ value }) => (value ? formatDate(new Date(value), 'LLL dd hh:mm aa') : '-'),
    filter: 'agDateColumnFilter',
  },

  percentColumn: {
    valueFormatter: ({ value }) =>
      value
        ? Number(value / 100).toLocaleString(undefined, {
            style: 'percent',
            minimumFractionDigits: 2,
          })
        : '-',
  },

  currencyColumn: {
    valueFormatter: ({ value }) =>
      value ? formatCurrency({ amount: value, minimumFractionDigits: 0 }) : '-',
  },

  booleanCheckColumn: {
    valueFormatter: ({ value }) => {
      if (value === undefined) return ''
      if (value === null) return '-'
      return value ? '✅' : 'No'
    },
  },
}
